import "../Component2/css/Termcondition.css";
import SEO from "../SEO";
import { seoConfig } from "../config/seoConfig";
import logo from "../Component2/Image/logo2.png";
function Termscondition() {
  return (
    <>
      <SEO
        title={seoConfig.c_term.title}
        description={seoConfig.c_term.description}
      />
      <div className="ctc-body">
        <div
          className="ctc-wrapper"
          style={{ backgroundImage: `url(${logo})` }}
        >
          <div className="ctc-container">
            <h2 className="ctc-title">Candidate Terms & Conditions</h2>
            <h6
              className=""
              style={{ textAlign: "center", fontWeight: "bold" }}
            >
              Hirelink Infotech Pvt Ltd – HirelinkInfo Pharma Job Portal
            </h6>

            <h3 className="ctc-heading">1. Objective of the Platform</h3>
            <p className="ctc-text">
              Hirelink Infotech Pvt Ltd and its affiliated platforms
              (“HirelinkInfo”) operate solely as a digital job portal to enable
              communication, job discovery, and career opportunities for
              candidates genuinely seeking employment in the pharmaceutical and
              allied industries. The platform is not a recruitment agency and
              does not guarantee interviews, job offers, salary outcomes, or
              employer responses. By accessing https://hirelinkinfo.com or using
              the HirelinkInfo Android or iOS mobile application, you agree to
              be legally bound by these Terms & Conditions.
            </p>
            <h3 className="ctc-heading">
              2. Account Registration & User Responsibility
            </h3>
            <p className="ctc-text">
              1. Candidates must create an account using true, accurate, and
              complete information.<br></br> 2. You are fully responsible for
              maintaining the confidentiality of your username, password, OTPs,
              and verification credentials.<br></br> 3. Any activity performed
              through your account will be treated as authorized by you, whether
              done intentionally or not.<br></br> 4. Sharing credentials,
              transferring accounts, sublicensing access, or allowing
              third-party use is strictly prohibited.<br></br> 5. HirelinkInfo
              reserves the right to suspend, restrict, or permanently terminate
              accounts for violations without prior notice.
            </p>

            <h3 className="ctc-heading">3. Candidate Signup Fee (Mandatory)</h3>
            <p className="ctc-text">
              ● A one-time candidate registration fee of ₹300 + 18% GST is
              applicable.<br></br>● This fee is strictly non-refundable under
              all circumstances.<br></br>● Payment grants access to premium
              job-portal features only and does not guarantee placement.
              <br></br>● Failure to receive interview calls or job offers does
              not entitle the candidate to a refund.
            </p>

            <h3 className="ctc-heading">
              4. Candidate Score & Interview Attendance Policy
            </h3>
            <p className="ctc-text">
              To ensure employer trust and platform integrity, HirelinkInfo
              follows a candidate scoring system:
            </p>
            <p className="ctc-text">
              ● Default Candidate Score: 1000 points upon registration<br></br>{" "}
              ● Interview No-Show Penalty: ○ If a candidate confirms an
              interview and does not attend, 50 points will be deducted{" "}
              <br></br>● Appointment Confirmation Deduction: ○ After successful
              appointment confirmation by the employer, 200 points will be
              deducted<br></br> ● Repeated no-shows or misuse may result in
              account suspension or permanent deactivation.<br></br>
              <br></br>This system ensures seriousness, fairness, and quality
              hiring across the pharma job portal.
            </p>

            <h3 className="ctc-heading">5. Acceptable Use Policy</h3>
            <p className="ctc-text">
              Candidates agree to use HirelinkInfo only for personal job-search
              purposes.
            </p>
            <p className="ctc-text" style={{ fontWeight: "bold" }}>
              You must NOT:
            </p>
            <p className="ctc-text">
              ● Copy, scrape, extract, crawl, or download platform data<br></br>
              ● Use content for commercial resale, redistribution, or AI /
              machine-learning training<br></br>● Misrepresent qualifications,
              experience, or identity<br></br>● Impersonate employers,
              recruiters, or other candidates<br></br>● Manipulate platform
              features or scores<br></br>
              <br></br>
              Any misuse will invite legal action, damages, and account
              termination.
            </p>

            <h3 className="ctc-heading">6. Accuracy of Information</h3>
            <p className="ctc-text">
              1. All resumes, profiles, certificates, experience details, and
              documents must be genuine and verifiable.<br></br>
              2. HirelinkInfo is not responsible for incorrect, misleading, or
              false information submitted by candidates.<br></br>
              3. Candidates shall indemnify HirelinkInfo against any loss or
              dispute arising from false data.
            </p>

            <h3 className="ctc-heading">
              7. Platform Nature & Employer Interaction
            </h3>
            <p className="ctc-text">
              ● HirelinkInfo is a public job portal with paid access features.
              <br></br>● The company does not verify or guarantee employer
              authenticity, interview outcomes, or job offers.<br></br>●
              Candidates must independently verify employer credentials before
              sharing sensitive documents or attending interviews.
            </p>

            <h3 className="ctc-heading">
              8. Communications & Anti-Spam Policy
            </h3>
            <p className="ctc-text">
              ● Sending unsolicited bulk messages, promotional emails, or spam
              through the platform is prohibited.<br></br>● Repeated or
              irrelevant job applications, messages, or content posting may
              result in immediate termination.<br></br>● HirelinkInfo reserves
              the right to monitor, filter, block, or restrict communications.
            </p>

            <h3 className="ctc-heading">9. Content Restrictions</h3>
            <p className="ctc-text">
              Candidates must not upload, post, transmit, or distribute content
              that:
            </p>
            <p className="ctc-text">
              ● Is illegal, abusive, defamatory, obscene, hateful, or misleading
              <br></br>● Violates privacy, intellectual property, or contractual
              rights.<br></br>● Contains malware, viruses, or harmful code.
              <br></br>● Encourages criminal activity or threatens India’s
              sovereignty, security, or public order.
            </p>

            <h3 className="ctc-heading">10. Data Privacy & Usage</h3>
            <p className="ctc-text">
              ● Candidate data is used to improve job matching, visibility,
              recommendations, and platform performance.<br></br> ● Personally
              identifiable information is not sold to third parties.<br></br> ●
              Data may be shared only with:<br></br> ○ Authorized
              employers/recruiters<br></br> ○ Platform service providers
              <br></br> ○ Legal authorities when required by law<br></br>
              <br></br>
              Complete confidentiality cannot be guaranteed due to the public
              nature of job portals.
            </p>

            <h3 className="ctc-heading">11. Third-Party Links</h3>
            <p className="ctc-text">
              ● The platform may contain links to third-party websites.<br></br>
              ● HirelinkInfo does not endorse or control such sites.<br></br>●
              Accessing external links is done entirely at the candidate’s own
              risk.
            </p>

            <h3 className="ctc-heading">12. Security Measures</h3>
            <p className="ctc-text">
              ● Automated and manual security systems detect suspicious or
              fraudulent activity.<br></br> ● Additional verification (OTP,
              biometric, photo, SMS, or app-based security tools) may be
              required.<br></br> ● Refusal to comply may restrict or block
              access.<br></br> ● Candidates must keep devices secure, updated,
              and untampered.
            </p>
            <p className="ctc-text">
              By registering, you consent to receiving SMS verification codes
              and security notifications.
            </p>

            <h3 className="ctc-heading">13. Legal Compliance</h3>
            <p className="ctc-text">Candidates must comply with:</p>
            <p className="ctc-text">
              ● Information Technology Act, 2000<br></br>● All applicable Indian
              laws and regulations<br></br>● Google Play Store & Apple App Store
              policies<br></br>
            </p>
            <p className="ctc-text">
              Any violation may attract civil and criminal liability.
            </p>

            <h3 className="ctc-heading">14. Payments, Refunds & Liability</h3>
            <p className="ctc-text">
              ● All payments are 100% advance.<br></br>● Refunds, if any, are at
              the sole discretion of Hirelink Infotech Pvt Ltd.<br></br>● No
              warranty is provided for uptime, job results, or platform
              availability.<br></br>● Liability, if applicable, is strictly
              limited to the amount paid.<br></br>● Free services carry no
              liability.
            </p>

            <h3 className="ctc-heading">15. Platform Availability</h3>
            <p className="ctc-text">
              You agree to indemnify and hold harmless Hirelink Infotech Pvt
              Ltd, its directors, employees, partners, and affiliates from any
              claims, damages, losses, or legal actions arising from:
            </p>
            <p className="ctc-text">
              ● Error-free operation<br></br>● Virus-free access<br></br>●
              Continuous availability
            </p>

            <h3 className="ctc-heading">16. Indemnity</h3>
            <p className="ctc-text">
              HirelinkInfo strives for uninterrupted service but does not
              guarantee:
            </p>
            <p className="ctc-text">
              ● Your platform usage<br></br>● Your submitted data<br></br>● Your
              violation of these Terms
            </p>

            <h3 className="ctc-heading">
              17. Dispute Resolution & Jurisdiction
            </h3>
            <p className="ctc-text">
              ● All disputes shall be resolved by arbitration in Nashik,
              Maharashtra, under the Arbitration & Conciliation Act, 1996.
              <br></br>● Indian law shall govern the agreement.<br></br>● Courts
              at Nashik shall have exclusive jurisdiction.
            </p>

            <h3 className="ctc-heading">18. Termination of Access</h3>
            <p className="ctc-text">Non-compliance may result in:</p>
            <p className="ctc-text">
              ● Immediate suspension<br></br>● Permanent account termination
              <br></br>● Content removal<br></br>● Legal action where applicable
            </p>

            <h3 className="ctc-heading">19. Acceptance of Terms</h3>
            <p className="ctc-text">
              By registering, paying the ₹300 + 18% GST non-refundable fee, or
              using the HirelinkInfo website or mobile app, you confirm that you
              have read, understood, and agreed to these Candidate Terms &
              Conditions.
            </p>

            <p className="ctc-footer-text" style={{ fontWeight: "bold" }}>
              © {new Date().getFullYear()} All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Termscondition;
